import {
  CustomerInformationStepData,
  AccountResponse,
  SaveOnboardingFormPayload,
  STATION_USAGE_TYPES,
} from '../constants';

export const splitFullName = (fullName: string): { firstName: string; lastName: string } => {
  const parts = fullName.trim().split(' ');
  if (parts.length === 0 || (parts.length === 1 && parts[0] === '')) {
    return { firstName: '', lastName: '' };
  }
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  const firstName = parts[0];
  const lastName = parts.slice(1).join(' ');
  return { firstName, lastName };
};

export const convertCustomerInformationStepDataToDTO = (
  customerInformationStepData: CustomerInformationStepData,
  accountData: AccountResponse | null,
  formId?: string,
  region?: string,
): SaveOnboardingFormPayload => {
  const { firstName, lastName } = splitFullName(customerInformationStepData.contactPerson.fullName || '');
  const { firstName: accountManagerFirstName, lastName: accountManagerLastName } = splitFullName(
    customerInformationStepData.accountManager?.fullName ?? '',
  );

  const payload: SaveOnboardingFormPayload = {
    salesforceAccountId: customerInformationStepData.customer?.accountId || '',
    region,
    siteData: {
      generalData: {
        siteAddress: {
          streetAddress: customerInformationStepData.siteAddress.streetAddress || '',
          city: customerInformationStepData.siteAddress.city || '',
          state: customerInformationStepData.siteAddress.state || '',
          country: customerInformationStepData.siteAddress.country || '',
          zipCode: customerInformationStepData.siteAddress.zipCode || '',
        },
        contactPerson: {
          firstName,
          lastName,
          email: customerInformationStepData.contactPerson.email ?? '',
        },
        accountManager: {
          firstName: accountManagerFirstName,
          lastName: accountManagerLastName,
          email: customerInformationStepData.accountManager?.email ?? '',
        },
        stationTier: customerInformationStepData.tier || '',
        stationUsageType: customerInformationStepData.stationUsageType || STATION_USAGE_TYPES.REGULAR,
        ecoplantCustomerId: customerInformationStepData.account || '',
        customerName: accountData?.customerName || customerInformationStepData.newCustomerName || '',
        channelIdentifier: accountData?.cgOrgChannelC || '',
      },
    },
  };

  if (formId) {
    payload.formId = formId;
  }

  return payload;
};
